import { FC } from 'react';
import { Item } from '@/redux/back-dashboard-api';
import { isTruthy } from '@pcmp-checka/lib-utilities/array';
import { Trans, useTranslation } from 'react-i18next';
import ListView, { ListViewItem } from '@ingka/list-view';
import Accordion, { AccordionItem } from '@ingka/accordion';

const MEASURES: Record<
  keyof Omit<Item['properties'], '__typename'>,
  (value: any) => string
> = {
  width: (value) => `${value} cm`,
  weight: (value) => `${value} kg`,
  height: (value) => `${value} cm`,
  depth: (value) => `${value} cm`,
  material: (value) => value,
};

export const ItemProperties: FC<{
  properties: Item['properties'];
}> = ({ properties }) => {
  // Hooks
  const { t } = useTranslation();
  // Data
  const props = Object.entries(properties || {})
    .filter(([_, value]) => isTruthy(value))
    .map(([key, value]) => ({
      key,
      // @ts-ignore
      value: MEASURES[key](value),
      i18nKey: `label.item.properties.${key}`,
    }));

  if (!props.length) return null;

  return (
    <>
      <Accordion size="small">
        <AccordionItem
          id={`accordion-item`}
          key={'key'}
          title={<p className="px-6">{t('label.product.information')}</p>}
        >
          {props.map(({ key, value, i18nKey }) => (
            <p key={key} id={key} className="text-sm leading-snug px-6">
              <b>
                <Trans i18nKey={t(i18nKey)} />
              </b>
              : <Trans i18nKey={value} />
            </p>
          ))}
        </AccordionItem>
      </Accordion>
    </>
  );
};

export const ItemDocuments: FC<{
  documents?: Item['documents'];
}> = ({ documents }) => {
  // Hooks
  const { t } = useTranslation();

  if (!documents?.length) return null;

  return (
    <>
      <Accordion size="small">
        <AccordionItem
          id={`accordion-item`}
          key={'key'}
          title={<p className="px-6">{t('label.product.documents')}</p>}
        >
          <ListView id="item-documents" size="small">
            {documents.map(({ name, url }) => (
              <ListViewItem
                key={url}
                className="text-sm leading-snug px-6 !border-b-0"
                title={name}
                emphasised={true}
                href={url}
                control="link"
                controlIcon="linkOut"
                newWindow="blank"
              />
            ))}
          </ListView>
        </AccordionItem>
      </Accordion>
    </>
  );
};
